import {createSlice} from '@reduxjs/toolkit';
import {httpPost, httpGet} from '../../util/Rest';

const initialData = {
  letterGroupData: {},
  letterGroupStatus: null,
  isLoading: false,
  errorMsg: null,
  successMsg: null,
  userMetrix: '',
  overridingData: {},
  letterGroupUsageData: {},
  letterGroupRowData: {},
};

const slice = createSlice({
  name: 'login',
  initialState: {
    ...initialData,
  },
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchLetterGroupData: (state, action) => {
      state.letterGroupData = action.payload;
      state.isLoading = false;
      state.errorMsg = action?.payload?.data?.message;
      state.successMsg = action?.payload?.response;
    },
    postLetterGroupData: (state, action) => {
      state.letterGroupStatus = action.payload.status;
      state.isLoading = false;
      state.errorMsg = action?.payload?.data?.message;
      state.successMsg = action?.payload?.response;
    },
    postAddLetterGroupData: (state, action) => {
      state.isLoading = false;
      state.userMetrix = action.payload.response.userMetrix;
      state.overridingData = action.payload.response.placeResponse;
    },
    resetData: (state) => {
      state.letterGroupData = {};
      state.letterGroupStatus = null;
      state.isLoading = false;
      state.successMsg = null;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action?.payload?.data?.message ? action.payload.data.message : '';
      state.isLoading = false;
    },
    resetUserMetrix: (state) => {
      state.userMetrix = '';
      state.overridingData = {};
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.response;
      state.isLoading = false;
    },
    resetPrintUsageData: (state, action) => {
      state.letterGroupUsageData = {};
      state.letterGroupRowData = {};
    },
    // getLetterRuleGroupUsageData: (state, action) => {
    //   state.formulaUsageResponse = action.payload;
    //   state.isLoading = false;
    //   state.errorMsg = null;
    //   state.successMsg = action.payload.response;
    // },
    setLetterGroupRowData: (state, action) => {
      state.letterGroupRowData = action.payload;
    },
    setLetterGroupUsage: (state, action) => {
      state.isLoading = false;
      state.errorMsg = null;
      state.letterGroupUsageData = action.payload;
    },
  },
});

export default slice.reducer;

// Actions

export const {
  postLetterGroupData,
  fetchStart,
  fetchLetterGroupData,
  fetchError,
  resetData,
  postAddLetterGroupData,
  resetUserMetrix,
  getLetterRuleGroupUsageData,
  setLetterGroupRowData,
  setLetterGroupUsage,
  resetPrintUsageData,
  fetchSuccess,
} = slice.actions;

export const fetchLetterGroup = (id) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/find/lettergroup/${id}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(fetchLetterGroupData(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postLetterGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`lettermaintenance/save/letterGroup`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (
          data &&
          data.status &&
          data.status === 200 &&
          data.response.userMetrix === 'Yes'
        ) {
          dispatch(postAddLetterGroupData(data));
        } else if (data && data.status && data.status === 200) {
          // dispatch(fetchError(data));
          dispatch(postLetterGroupData(data));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchLetterGroupUsage = (code) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`lettermaintenance/usage/letergroup/${code}`)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
          dispatch(fetchError(data));
        } else if (data && data.status && data.status === 200) {
          dispatch(setLetterGroupUsage(data.response));
          dispatch(fetchSuccess(data.response));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const resetLetterGroup = () => {
  return (dispatch) => {
    dispatch(resetData());
  };
};

export const ResetUserMetrix = () => {
  return (dispatch) => {
    dispatch(resetUserMetrix());
  };
};
